import { TripMaped } from "pages/private/TripSelector/TripSelector.model";
import { checkTripName, NOTES_NOT_SUPPORTED } from "pages/private/TripSelector/TripSelector.service";

export function filterTripsFromService(initialTrips: any[], options?: any) {
    let aux: any[] = []
    let transports: any[] = options?.transportcard ? options.transportcard : [];

    if (initialTrips && initialTrips.length > 0) {

        //primero guardamos los transportes permitidos
        let transportsAllowed = ["walk"]
        transports.forEach((transport: any) => {
            if (transport.selected) transportsAllowed.push(transport.id) // si está seleccionado
        })

        // ahora recorremos los leg y vemos si tienen algún transporte no permitido
        initialTrips.forEach((el: any) => {
            let allowedTrip = true;
            if (el?.LegList?.Leg) {
                el.LegList.Leg.forEach((leg: any) => {
                    const type = switchTransportsType(leg);
                    if (transportsAllowed.includes(type)) {
                        //correcto
                    } else {
                        allowedTrip = false;
                    }
                });
            } else {
                allowedTrip = false;
            }
            if (allowedTrip) aux.push(el);
        })
    }
    return aux;
}
// /**
//  * @description función que mapea los viajes para el card de viaje
//  * @param trip 
//  * @returns 
//  */
// export function mapResultTrip(trip: any) {
//     const { originHour, originMinutes, destinationHour, destinationMinutes, diff } = getTimeBetween(trip);
//     let tarifs = []
//     if (trip?.TariffResult?.fareSetItem) {
//         tarifs = getTarifs(trip?.TariffResult?.fareSetItem);
//     }
//     let departureTime = `${[originHour, originMinutes].join(":")} - ${[destinationHour, destinationMinutes].join(":")}`;
//     let totalTime = `${Math.floor(diff / 1000 / 60 / 60)}h ${diff / 1000 / 60 % 60}min`;
//     let price = tarifs ? calcPriceTagFromTarifs(tarifs) : "";
//     const output = {
//         departureTime,
//         totalTime,
//         price
//     }

//     return output
// }
/**
 * @description función que calcula el precio total de cada uno de los viajes
 * @param tarifsArray 
 * @returns 
 */
export function calcPriceTagFromTarifs(tarifsArray: any): string {
    let sum = 0;
    tarifsArray.forEach((tarif: any) => {
        sum += tarif[0].price;
    })
    sum = Math.floor(sum * 100) / 100;
    return `${formatPrice(sum)} €`;
}
/**
* @description función que monta el array de tarifas, que se usará luego para setear las tarifas de las legs del trayecto
* se lanza al pulsar en un viaje.
* @param fareSetItem 
* @returns 
*/
export function getTarifs(fareSetItem: any) {
    let tarifs: any[] = [];
    fareSetItem.forEach((el: any) => {
        let index = el.fromLegId;
        let lastIndex = el.toLegId;
        let tarifas: any[] = []
        el.fareItem[0].ticket?.forEach((ta: any) => {
            if (ta.cur == "EUR") {
                tarifas.push({
                    price: ta.price / 100,
                    currency: ta.cur,
                    desc: ta.desc || ta.name,
                    param: ta.param,
                    shpCtx: ta.shpCtx
                })
            }
        })

        while (index <= lastIndex) {
            if (tarifs[index]) {
                tarifs[index] = tarifs[index].concat(tarifas);
            } else {
                tarifs[index] = tarifas;
            }
            index++;
        }

        // // ordenamos las tarifas desde más baratas
        // tarifs.forEach((tar: any) => {
        //     tar.sort((a: any, b: any) => {
        //         return a.price - b.price;
        //     });
        // })

    });
    return tarifs
}
/**
 * @description Función que formatea el precio con coma y dos dígitos.
 * @param {string | number} price Precio a formatear (string o numérico)
 * @returns {string} Precio formateado en X,XX
 */
export function formatPrice(price: string | number) {
    if (isNaN(parseFloat(price + ''))) { price = '0' } // FIX: si viene NaN se setea 0.
    let text = price + '';
    let coste = parseFloat(text).toFixed(2);
    let priceFormatted = coste.replace('.', ',');
    return priceFormatted;
}

export function formatPriceRemoveComma ( price: string){
    price = price.replace(",","");
    return formatPrice(price);
}



export function formatPriceNumber(price: number) {
    if(!price) {
        return '0,00 €'
    }
    const realPrice = price /100;
    let cost = realPrice.toFixed(2);
    let priceFormatted = `${cost.replace('.', ',')} €`;
    return priceFormatted;
}

export function formatNumber(price: number) {
    if(!price) {
        return '0,00'
    }
    const realPrice = price /100;
    let cost = realPrice.toFixed(2);
    let priceFormatted = `${cost.replace('.', ',')}`;
    return priceFormatted;
}


/**
 * @description función que calcula el precio del botón de seleccionar viaje
 * @param legs 
 * @returns 
 */
export function calcCurrentPrice(legs: any): { sum: number, desc: string } {
    let sum = 0;
    legs.forEach((leg: any) => {
        sum += leg.pricetag.price
    })
    sum = Math.floor(sum * 100) / 100;
    return { sum, desc: formatPrice(sum) + " €" };
}
/**
 * @description función que calcula el tiempo de cada viaje
 * @param trip 
 * @returns 
 */
export function getTimeBetween(trip: any) {
    try {
        let [originHour, originMinutes, originSeconds] = trip?.Origin?.time?.split(":")
        let [destinationHour, destinationMinutes, destinationSeconds] = trip?.Destination?.time?.split(":")
        let originDate = new Date(trip?.Origin?.date?.replace(/-/g, '/') + " " + trip?.Origin?.time)
        let destinationDate = new Date(trip?.Destination?.date?.replace(/-/g, '/') + " " + trip?.Destination?.time)
        var diff = Math.abs((destinationDate as any) - (originDate as any));
        return { originHour, originMinutes, originSeconds, destinationHour, destinationMinutes, destinationSeconds, diff };
    } catch (error) {

        return { originHour: '', originMinutes: '', originSeconds: '', destinationHour: '', destinationMinutes: '', destinationSeconds: '', diff: 0};
    }
}

/**
 * Retorna el literal del transporte correspondiente.
 * @param step Transporte o andar
 * @param minutes Duración
 * @returns Literal del transporte correspondiente
 */
export function switchTransports(step: any, minutes?: number) {
    let icon = "andar"
    let transportTypeString = ""
    let transportNameString = ""; // solo aplica a taxis
    switch (step.type) {
        case "TRSF":
            icon = "transbordo";
            break;
        case "WALK":
            icon = "andar";
            break;
        case "TAXI":
            // mapees karhoo como si fuera bolt
            if (step.name === 'Karhoo') {
                // Logica bolt
                icon = "taxiVtc";
                transportTypeString = ETransportLiterals.taxi
                transportNameString = step.name.toUpperCase();
            }
            else if (step.name === 'Movitaxi') {

                transportNameString = step.name.toUpperCase();
                icon = "taxiVtc";
                transportTypeString = ETransportLiterals.taxi;
            }
            else {
                icon = "taxiVtc";
                transportTypeString = ETransportLiterals.taxi;
            }
            break;
        case "BIKE":
            switch (step.name) {
                case "cooltra":
                    icon = "moto";
                    transportTypeString = ETransportLiterals.cooltra;
                    break;
                case "Reby eScooter":
                    icon = "patinete";
                    transportTypeString = ETransportLiterals.reby;
                    break;
                case "reby-escooter":
                    icon = "patinete";
                    transportTypeString = ETransportLiterals.reby;
                    break;
                default:
                    icon = "unknown";
                    break;
            }
            break;
        default:
            switch (step.Product[0]?.cls) {
                case "4": /* RENFE */
                    if (step.Product[0]?.operatorCode === "107") {

                        // Trenes
                        if (step.Product[0]?.operator === "RENFE OPERADORA") {
                            if (step.Product[0]?.line === "AVE") {
                                icon = "ave";
                                transportTypeString = ETransportLiterals.ave;
                            }
                            else if (step.Product[0]?.line === "AVLO") {
                                icon = "ave";
                                transportTypeString = ETransportTrainLiterals.avlo;
                            }
                            else if (step.Product[0]?.line === "ALVIA") {
                                icon = "ave";
                                transportTypeString = ETransportTrainLiterals.alvia;
                            }
                            else if (step.Product[0]?.line === "Intercit") {
                                icon = "ave";
                                transportTypeString = ETransportTrainLiterals.intercit;
                            }
                            else if (step.Product[0]?.line === "Euromed") {
                                icon = "ave";
                                transportTypeString = ETransportTrainLiterals.euromed;
                            }
                            else {
                                icon = "ave"
                                transportTypeString = 'unknown'; // si hay algun tren no controlado.
                            }
                        }
                        // Cercanias
                        else {
                            icon = "cercanias";
                            transportTypeString = ETransportLiterals.cercanias;
                        }


                    } else {
                        icon = "cercanias";
                        transportTypeString = ETransportLiterals.cercanias;
                    }
                    break;
                case "256": /* BUS */
                    icon = "busLD";
                    transportTypeString = ETransportLiterals.busUrb;
                    break;
                case "64": /* CRM METRO */
                    icon = "metro";
                    transportTypeString = ETransportLiterals.metro;
                    break;
                case "128": /* ?? */
                    icon = "cercanias";
                    transportTypeString = ETransportLiterals.cercanias;
                    break;
                default:
                    icon = "unknown";
                    break;
            }
    }
    // if(minutes > 5 && icon == "andar"){
    const isWalk: boolean = (icon === "andar" || icon === "transbordo");
    return {
        icon,
        transportTypeString,
        text: isWalk ? minutes?.toString() : step?.Product[0]?.line || checkTripName(step) || "",
        size: "24px",
        background: getTransportColor(!!transportNameString ? transportNameString : icon)
    }
    // }
}

/* ORDENACIÓN DE TRIPS */
export function compareMoney(a: any, b: any) {
    if (a.price && b.price) {
        let moneyA = parseFloat(a.price.split(" ")[1].split(",").join("."))
        let moneyB = parseFloat(b.price.split(" ")[1].split(",").join("."))
        if (moneyA < moneyB) {
            return -1;
        }
        if (moneyA > moneyB) {
            return 1;
        }
    }
    return 0;
}

/* DOCO-63: Filtra por rápido ordenando también por económico */
export function filterByDirect(a: TripMaped, b: TripMaped) {
    // Valores de tiempo
    
    const legsA = a?.trasportSection.length;
    const legsB = b?.trasportSection.length;

    const timeA = a?.sortInfo?.duration;
    const timeB = b?.sortInfo?.duration;

    const moneyA = a?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    const moneyB = b?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    /* Si el filtro rápido son iguales, ordena primero lo económico */
    if (legsA === legsB) {
        // console.log('son iguales de ecológico, voy a ordenar lo económico');
        if(timeA!==timeB){
            return  timeA < timeB ? -1 : 1;
        }else{
        if (moneyA === moneyB) {
            // console.log('Son iguales en lo economico, lo dejo como está');
            return 0;
        } else {
            // console.log('ordenado por económico', moneyA < moneyB ? -1 : 1 === 1 ? 'ordeno por delante' : 'ordeno por detrás');
            return moneyA < moneyB ? -1 : 1; // Ordena primero los que son más económicos.
        }
    }
    } else {
        return legsA < legsB ? -1 : 1; // Ordena primero los que menos tiempo tarda el viaje.
    }
    return 0;
}

/* DOCO-63: Filtra por rápido ordenando también por económico */
export function filterBySpeed(a: TripMaped, b: TripMaped) {
    // Valores de tiempo
    const timeA = a?.sortInfo?.duration;
    const timeB = b?.sortInfo?.duration;

    const moneyA = a?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    const moneyB = b?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    /* Si el filtro rápido son iguales, ordena primero lo económico */
    if (timeA === timeB) {
        // console.log('son iguales de ecológico, voy a ordenar lo económico');
        if (moneyA === moneyB) {
            // console.log('Son iguales en lo economico, lo dejo como está');
            return 0;
        } else {
            // console.log('ordenado por económico', moneyA < moneyB ? -1 : 1 === 1 ? 'ordeno por delante' : 'ordeno por detrás');
            return moneyA < moneyB ? -1 : 1; // Ordena primero los que son más económicos.
        }
    } else {
        return timeA < timeB ? -1 : 1; // Ordena primero los que menos tiempo tarda el viaje.
    }
    return 0;
}
/* DOCO-63: Filtra por ecológico ordenando también por económico */
export function filterByEcologic(a: TripMaped, b: TripMaped) {

    // Valores de tiempo
    const ecoA = a?.sortInfo?.ecologic;
    const ecoB = b?.sortInfo?.ecologic;

    const moneyA = a?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    const moneyB = b?.sortInfo?.price || 0; // setear a 0 cuando es undefined

    /* Si los ecologicos son iguales, ordena primero lo económico */
    if (ecoA === ecoB) {
        // console.log('son iguales de ecológico, voy a ordenar lo económico');
        if (moneyA === moneyB) {
            // console.log('Son iguales en lo economico, lo dejo como está');
            return 0;
        } else {
            // console.log('ordenado por económico', moneyA < moneyB ? -1 : 1 === 1 ? 'ordeno por delante' : 'ordeno por detrás');
            return moneyA < moneyB ? -1 : 1; // Ordena primero los que son más económicos.
        }
    } else {
        return ecoA < ecoB ? 1 : -1; // Ordena primero los que son más ecológicos.
    }

}
/* DOCO-63: Filtra por económico ordenando también por rápidez */
export function filterByEconomic(a: TripMaped, b: TripMaped) {
    // Valores precio
    let moneyA = a.sortInfo.price || 0; // setear a 0 cuando es undefined
    let moneyB = b.sortInfo.price || 0; // setear a 0 cuando es undefined
    if (moneyA === moneyB) {
        // Valores de tiempo
        const timeA = a?.sortInfo?.duration;
        const timeB = b?.sortInfo?.duration;
        if (timeA === timeB) {
            return 0;
        } else {
            return timeA < timeB ? -1 : 1;
        }
    } else {
        return moneyA < moneyB ? -1 : 1;
    }
}

export function filterByEconomicLongMover(a: TripMaped, b: TripMaped) {
    // Valores precio
    let moneyA = a.sortInfo.price || 0; // setear a 0 cuando es undefined
    let moneyB = b.sortInfo.price || 0; // setear a 0 cuando es undefined
    if (moneyA === moneyB) {
        // Valores de tiempo
        const timeA = a?.sortInfo?.duration;
        const timeB = b?.sortInfo?.duration;
        if (timeA === timeB) {
            return 0;
        } else {
            return timeA < timeB ? -1 : 1;
        }
    } else {
        if(moneyA < moneyB){
       return -1

        }else{
            if(moneyB===0){
                return -1
            }else{
                return 1
            }
        }
        //return moneyA < moneyB ? -1 : 1;
    }
}

/* PRIVATE FUNCTIONS */
/**
 * Modifica el type del transporte de cada viaje.
 * @param tripLeg Array de transportes
 * @returns Sobreescribe el Array de transportes con el type de transporte correcto.
 */
function switchTransportsType(tripLeg: any) {
    let type = "walk";
    switch (tripLeg.type) {
        case "TRSF":
            break;
        case "WALK":
            break;
        case "TAXI":
            type = "taxiVtc";
            break;
        case "BIKE":
            switch (tripLeg.name) {
                case "cooltra":
                    type = "moto";
                    break;
                case "Reby eScooter":
                    type = "moto";
                    break;
                default:
                    type = "moto";
                    break;
            }
            break;
        default:
            switch (tripLeg.Product[0]?.cls) {
                case "4":
                    type = "ave";
                    break;
                case "256":
                    type = "busLD";
                    // type = tripLeg.Product[0]?.catIn === "EMT" ? "busUrb" : "busLD";
                    break;
                case "64":
                    type = "metro";
                    break;
                case "128":
                    type = "ave";
                    break;
                default:
                    break;
            }
    }
    return type;
}
/**
 * @description función para calcular las paradas de un item del detalle
 * @param leg 
 * @returns 
 */
export function getStops(leg: any): string[]|any{
    let output: string[] = [];

    
    if (leg?.Stops?.Stop) {
        Object.values(leg.Stops.Stop).forEach((el: any) => output.push(el.name))
    }else if(leg.Origin !==undefined && leg.Destination!==undefined){
        output.push(leg.Origin.name);
        output.push(leg.Destination.name);
    } else if(leg?.Stops === undefined) {
        return null;
    }
    return output;
}
/**
 * Retorna €/min
 * @param el 
 * @param index 
 * @returns 
 */
export function getPricePerTime(el: any, index: number): string | any {
    try {
      if(!!(el.Origin.Notes.Note[index].key.includes(NOTES_NOT_SUPPORTED))){
        return el.Origin.Notes.Note[index].value.replace('.', ',');
      }
   
    } catch (error) {
      return '';
    }
  }
/**
 * Retorna color del transporte
 * @param icon 
 * @returns {string} color en #FFFFFF
 */
export function getTransportColor(icon: string): string {
    let color = "#FFFFFF";
    switch (icon) {
        case "ave":
            color = "#9A337E";
            break;
        case "bici":
            color = "#027F97";
            break;
        case "busLD":
        case "busUrb":
            color = "#005DB9";
            break;
        case "cercanias":
            color = "#D90209";
            break;
        case "metro":
            color = "#02770A";
            break;
        case "moto":
            color = "#0172F0";
            break;
        case "patinete":
            color = "#613EEA";
            break;
        case "taxiVtc":
            color = "#6903C2";
            break;
        case "BOLT":
            color = "#2D8659";
            break;
        case "KARHOO":
            //color = "#6903C2";// taxi por defecto
            color = "#E80868";  // karhoo
            break;
        case "MOVITAXI":
            color = "#668D34";
            break;
        case "COCHE":
            color = "#DF6C01";
            break;
        case "tier":
            color = "#0E1A50";
        break;

        default:
            color = "#FFFFFF";
            break;
    }
    return color;
}
/**
 * @description función que calcula el precio de los items del detall
 * @param tarifsArray 
 * @returns 
 */
function calcPriceTag(tarifsArray: any) {
    return tarifsArray?.length > 0 ? {
        price: tarifsArray[0].price,
        text: `${formatPrice(tarifsArray[0].price)} € - ${tarifsArray[0].desc}`,
        type: tarifsArray.length > 1 ? "button" : "info"
    } : {
        price: 0,
        text: "No disponible",
        type: "info"
    }
}


/* INTERFACES */
export interface TripDetail {
    "orderId"?: any,
    "idPst": string,
    "transport": boolean,
    "icon"?: string,
    "transportTypeString"?: string,
    "isAproximetePriceElement"?: boolean,
    "isCarTransport"?: boolean,
    "isExternal"?: boolean,
    "departureTime"?: string,
    "arrivalTime"?: string,
    "direction"?: string,
    "showFooter"?: boolean,
    "tarifs"?: any[], // este array tiene las tarifas para utilizarlas en las modales
    "pricetag"?: any,
    "frecuency"?: string,
    "stops"?: string[],
    "line"?: {
        "text": string,
        "color": string
    },
    "duration"?: string,
    "showDrivingLicense"?: boolean,
    "literals": any, // literales específicas para el pst.
    "pricePerTime": string
    "trip": any,
    "buttonsFooter"?: any[],
    "classContentButtonsFooter"?: string,
    "cancelled"?: boolean,
    "cancelledCheckin"?: boolean,
    "state"?: string,
    "stateLiteral"?: string,
    "tripId"?: string,
    "directionTrip": string,
    "idJourney": number,
    "deleteButtonsActions"?: any,
    "allExtraDiscount"?:any,
    "variant"?:string,
    "paymentCard"?: paymentCard,
    "getConsultIncidence"?:any
}
export interface paymentCard{
    icon: string; name: string; number: string; date: string;isPastTravel:boolean
  }
export enum ETransportLiterals {
    metro = "Metro",
    ave = "AVE Larga distancia",
    bici = "Bici",
    busUrb = "Autobús urbano",
    cooltra = "Cooltra",
    reby = "Reby",
    taxi = "Taxi",
    cercanias = "Cercanias"
}
export enum ETransportTrainLiterals {
    avlo = "AVLO",
    alvia = "ALVIA",
    intercit = "Intercit",
    euromed = "Euromed "
}
export enum CurrencyLiteral {
    "EUR" = "€"
}

/* DOCO-63: Filtra por rápido ordenando también por económico */
export function filterByTime(a: TripMaped, b: TripMaped) {
    // Valores de tiempo
    const timeA = a?.origenHour ||'';
    const timeB = b?.origenHour ||'';

    const moneyA = a?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    const moneyB = b?.sortInfo?.price || 0; // setear a 0 cuando es undefined
    /* Si el filtro rápido son iguales, ordena primero lo económico */
    if (timeA === timeB) {
        // console.log('son iguales de ecológico, voy a ordenar lo económico');
        if (moneyA === moneyB) {
            // console.log('Son iguales en lo economico, lo dejo como está');
            return 0;
        } else {
            // console.log('ordenado por económico', moneyA < moneyB ? -1 : 1 === 1 ? 'ordeno por delante' : 'ordeno por detrás');
            return moneyA < moneyB ? -1 : 1; // Ordena primero los que son más económicos.
        }
    } else {
        return timeA < timeB ? -1 : 1; // Ordena primero los que menos tiempo tarda el viaje.
    }
    return 0;
}